<template>
    <header>
        <a
            href="#"
            @click.prevent.stop="onBackClick"
            v-if="showBackButton"
            class="button outline-button back-button"
        >
            <chevron-icon />Back
        </a>

        <router-link title="Broadway Business" to="/" class="logo">
            <lazy-image
                class="logo-screen"
                :src="logoSrc"
                :srcset="logoSrcSet"
                :sizes="logoSizes"
                :src-placeholder="logoPlaceholder"
                alt="Broadway Business"
            />
            <img
                v-if="showPrintLogo"
                class="logo-print"
                :src="logoPrintSrc"
                alt="Broadway Business"
            />
            <span class="subsite">
                <span class="subsite-title">
                    Grosses
                    <span class="beta-indicator">Beta</span>
                </span>
            </span>
        </router-link>
    </header>
</template>

<script>
import cl from 'src/util/cloudinary';
import ChevronIcon from 'src/components/icons/Chevron';
import { toSrcSet, mediaQueryWidth } from 'src/util/helpers';
import eventBus from 'src/util/eventBus';

export default {
    data() {
        return {
            logoWidth: 220,
            logoMobileWidth: 97,
            showPrintLogo: false,
        };
    },
    components: {
        ChevronIcon,
    },
    created() {
        this.onBeforePrint = () => (this.showPrintLogo = true);

        eventBus.$on('beforeprint', this.onBeforePrint);
    },
    destroyed() {
        eventBus.$off('beforprint', this.onBeforePrint);
    },
    computed: {
        logoPlaceholder() {
            return cl.url('grosses/blank', {
                width: this.logoWidth,
                height: Math.floor(this.logoWidth * 0.25),
                fetch_format: 'auto',
                crop: 'scale',
            });
        },
        logoSrc() {
            return this.logoAtSize(this.logoWidth);
        },
        logoSrcSet() {
            return toSrcSet({
                [`${this.logoMobileWidth}w`]: this.logoAtSize(
                    this.logoMobileWidth,
                ),
                [`${this.logoMobileWidth * 2}w`]: this.logoAtSize(
                    this.logoMobileWidth * 2,
                ),
                [`${this.logoWidth}w`]: this.logoAtSize(this.logoWidth),
                [`${this.logoWidth * 2}w`]: this.logoAtSize(this.logoWidth * 2),
            });
        },
        logoSizes() {
            return [
                `${mediaQueryWidth('medium', 'max')} ${this.logoMobileWidth}px`,
                `${this.logoWidth}px`,
            ].join(',');
        },
        logoPrintSrc() {
            return cl.url('grosses/broadway-business-print', {
                width: this.logoWidth,
                crop: 'scale',
                fetch_format: 'auto',
            });
        },
        showBackButton() {
            return (
                this.$route.path !== '/' && this.$route.path !== '/historical'
            );
        },
    },
    methods: {
        logoAtSize(width) {
            return cl.url('grosses/broadwaybusiness', {
                width,
                crop: 'scale',
                fetch_format: 'auto',
            });
        },
        onBackClick() {
            if (this.$store.state.app.seenHome) {
                return this.$router.go(-1);
            }

            return this.$router.push('/');
        },
    },
};
</script>
